// POC switch between the Command Center layouts: Board, Overview, Deck, Riso
// press, Strip board and the classic page. The choice is remembered per browser.
// Roll back one layout: delete its CommandCenter<Name>.{jsx,css,test.jsx} files
// and its entry in LAYOUTS. Roll back all: change the CommandCenter import in
// App.js back to "./pages/CommandCenter" and delete CommandCenterSwitch.*,
// CommandCenterStrips.*, CommandCenterRiso.*, CommandCenterDeck.*,
// CommandCenterOverview.*, CommandCenterBoard.* and
// useMorningBrief.js (fonts: src/assets/fonts/{bricolage,archivo}).
import React, { useState } from 'react';
import CommandCenter from './CommandCenter';
import CommandCenterStrips from './CommandCenterStrips';
import CommandCenterRiso from './CommandCenterRiso';
import CommandCenterDeck from './CommandCenterDeck';
import CommandCenterOverview from './CommandCenterOverview';
import CommandCenterBoard from './CommandCenterBoard';
import './CommandCenterSwitch.css';

const KEY = 'spcc:command-center-layout';
const LAYOUTS = [
  { id: 'board', label: 'Board', Page: CommandCenterBoard },
  { id: 'overview', label: 'Overview', Page: CommandCenterOverview },
  { id: 'deck', label: 'Deck', Page: CommandCenterDeck },
  { id: 'riso', label: 'Riso', Page: CommandCenterRiso },
  { id: 'strips', label: 'Strip board', Page: CommandCenterStrips },
  { id: 'classic', label: 'Classic', Page: null },
];
const read = () => { try { const saved = localStorage.getItem(KEY); return LAYOUTS.some(l => l.id === saved) ? saved : LAYOUTS[0].id; } catch { return LAYOUTS[0].id; } };

export default function CommandCenterSwitch() {
  const [layout, setLayout] = useState(read);
  const choose = value => {
    setLayout(value);
    try { localStorage.setItem(KEY, value); } catch { /* storage unavailable */ }
  };
  const toggle = <div className="cc-switch-row"><div className="cc-switch" role="group" aria-label="Command Center layout">
    {LAYOUTS.map(l => <button key={l.id} type="button" aria-pressed={layout === l.id} onClick={() => choose(l.id)}>{l.label}</button>)}
  </div></div>;
  const { Page } = LAYOUTS.find(l => l.id === layout);
  return Page ? <Page layoutSwitch={toggle} /> : <>{toggle}<CommandCenter /></>;
}
